<template>
  <div class="content">
    <el-form
      autocomplete="off"
      ref="form"
      label-position="top"
      :rules="rules"
      label-width="80px"
      :model="form"
    >
      <el-form-item label="邮箱账号" prop="email">
        <el-input
          autocomplete="off"
          v-model="form.email"
          placeholder="请输入邮箱"
        ></el-input>
        <div>
          <i class="el-icon-warning m-r-5" style="color: red"></i>如已在
          shoplazza 注册，请使用同一个邮箱
        </div>
      </el-form-item>

      <el-form-item label="密码" prop="password">
        <el-input
          autocomplete="off"
          type="password"
          v-model="form.password"
          placeholder="请输入密码"
        ></el-input>
      </el-form-item>
      <el-form-item label="会员" prop="user_type">
        <el-select v-model="form.user_type" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="vip套餐" v-if="form.user_type == 'vip'">
        <el-select v-model="form.vip_product_id" clearable placeholder="请选择">
          <el-option
            v-for="item in vipProductlist"
            :key="item.value"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="会员点数"
        prop="vip_point"
        v-if="form.user_type == 'vip'"
      >
        <el-input placeholder="请输入" v-model="form.vip_point"></el-input>
      </el-form-item>
      <el-form-item label="推荐码" prop="parent_invite_code">
        <el-input
          placeholder="请输入"
          v-model="form.parent_invite_code"
        ></el-input>
      </el-form-item>
      <el-form-item label="用户名称" prop="username">
        <el-input placeholder="请输入" v-model="form.username"></el-input>
      </el-form-item>
      <el-row type="flex" justify="space-between">
        <el-form-item label="姓" prop="last_name">
          <el-input placeholder="请输入" v-model="form.last_name"></el-input>
        </el-form-item>
        <el-form-item label="名" prop="first_name">
          <el-input placeholder="请输入" v-model="form.first_name"></el-input>
        </el-form-item>
      </el-row>
      <el-form-item label="公司" prop="company">
        <el-input placeholder="请输入" v-model="form.company"></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="contact">
        <el-input placeholder="请输入" v-model="form.contact"></el-input>
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input placeholder="请输入" v-model="form.address"></el-input>
      </el-form-item>
      <el-form-item>
        <el-row type="flex" justify="center">
          <el-button @click="back"> 返回 </el-button>
          <el-button
            v-if="form.id"
            type="primary"
            @click="store"
            :loading="btnLoading"
          >
            提交
          </el-button>
          <el-button v-else type="primary" @click="store" :loading="btnLoading">
            创建
          </el-button>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      options: [
        {
          value: 'vip',
          label: '会员',
        },
        {
          value: 'operations_personnel',
          label: '网红',
        },
        {
          value: 'ordinary_user',
          label: '非VIP',
        },
      ],
      vipProductlist: [],
      form: {
        id: '',
        email: '',
        password: '',
        username: '',
        address: '',
        company: '',
        contact: '',
        first_name: '',
        last_name: '',
        user_type: '',
        vip_point: '',
        parent_invite_code: '',
        vip_product_id: '',
      },
      rules: {
        email: [
          { required: true, message: '邮箱账号不能为空', trigger: 'change' },
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'change' },
        ],
        user_type: [
          { required: true, message: '会员不能为空', trigger: 'change' },
        ],
        vip_point: [
          { required: true, message: '会员点数不能为空', trigger: 'change' },
        ],
        vip_product_id: [
          {
            required: true,
            message: 'vip套餐不能为空',
            trigger: 'change',
          },
        ],
        parent_invite_code: [
          { required: true, message: '推荐码不能为空', trigger: 'change' },
        ],
        first_name: [
          { required: true, message: '请输入姓', trigger: 'change' },
        ],
        last_name: [{ required: true, message: '请输入名', trigger: 'change' }],
        company: [
          { required: true, message: '公司不能为空', trigger: 'change' },
        ],
        contact: [
          { required: true, message: '联系方式不能为空', trigger: 'change' },
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'change' },
        ],
        username: [
          { required: true, message: '用户名称不能为空', trigger: 'change' },
        ],
        address: [
          { required: true, message: '地址不能为空', trigger: 'change' },
        ],
      },
      btnLoading: false,
    }
  },
  mounted() {
    console.log(this.$route.query)
    if (this.$route.query.id) {
      this.getuserinfo(this.$route.query.id)
    } else {
      setTimeout(() => {
        this.form = {
          id: '',
          email: '',
          password: '',
          company: '',
          contact: '',
          first_name: '',
          last_name: '',
          user_type: '',
          vip_point: 0,
          parent_invite_code: '',
          vip_product_id: undefined,
        }
        this.$forceUpdate()
      }, 100)
    }
    this.getvipProduct()
  },
  methods: {
    back() {
      this.$router.back()
    },
    getuserinfo(id) {
      this.form.id = id
      request({
        url: '/api/backend/users/detail',
        method: 'get',
        params: {
          id: id,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.form = res.data
        }
      })
    },
    getvipProduct() {
      request({
        url: '/api/backend/vipProduct/list',
        method: 'get',
      }).then((response) => {
        this.vipProductlist = response.data.data
      })
    },
    store() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/users/store',
            method: 'post',
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.$router.push({
                path: '/USER/userlist',
              })
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
  },
}
</script>

<style>
.content {
  padding: 20px;
  width: 50%;
  height: 100%;
}
</style>
